import { useSelector } from '@bonanza-social/toolkit/state';
import {
  selectHasUnreadInboxMessages,
  selectInboxDataState,
} from '../state/inbox.slice';
import { useMemo } from 'react';
import { InboxMessageCategory } from '../state';
import { InboxMessageResponseSchema } from '../services/InboxService/InboxService.schemas';
import z from 'zod';
import Config from '@bonanza-social/toolkit/config';

type InboxMessage = z.infer<typeof InboxMessageResponseSchema>;

const useInbox = (type: InboxMessageCategory) => {
  const inboxDataState = useSelector(selectInboxDataState);
  const hasUnreadMessages = useSelector(selectHasUnreadInboxMessages);

  const transmitter = Config.ER_URL;

  const inbox: InboxMessage[] = [
    {
      id: 100000,
      category: 'Status',
      type: 'Status',
      isRead: false,
      cta: {
        type: 'NavigationTransmit',
        text: 'Discover available rewards.',
        isClicked: false,
        details: transmitter,
      },
      title: 'Enjoying Bonanza?',
      body: '',
    },
  ];

  return useMemo(
    () => ({
      inbox,
      inboxDataState,
      hasUnreadMessages,
    }),
    [inboxDataState, hasUnreadMessages],
  );
};

export default useInbox;
